export type ContentRevision = Date | number | string | undefined;

const appendQueryParameter = (
  url: string,
  name: string,
  value: string,
): string => {
  const hashIndex = url.indexOf('#');
  const hash = hashIndex >= 0 ? url.slice(hashIndex) : '';
  const baseUrl = hashIndex >= 0 ? url.slice(0, hashIndex) : url;
  const separator = baseUrl.includes('?') ? '&' : '?';

  return `${baseUrl}${separator}${name}=${encodeURIComponent(value)}${hash}`;
};

const normalizeRevision = (revision: ContentRevision): string =>
  revision instanceof Date ? revision.valueOf().toString() : String(revision);

export const withContentRevision = (
  url: string,
  revision: ContentRevision,
): string => {
  if (!url || revision === undefined || revision === '') {
    return url;
  }

  return appendQueryParameter(url, 'gccRevision', normalizeRevision(revision));
};

export const withContentRevalidation = (
  url: string,
  loadToken: string | number,
  attempt: number,
): string =>
  appendQueryParameter(
    url,
    'gccRevalidation',
    `${loadToken}-${attempt}`,
  );
